<template>
    <div class="education-filter mb-2">
        <div
            v-for="item in filter.filters"
            :key="item.id"
            class="education-filter__option mr-1 d-inline-block"
        >
            <input
                :id="item.name"
                v-model="selectedFilters"
                class="education-filter__input"
                type="checkbox"
                :value="item"
                @input="changeHandler(item)"
            />
            <label :for="item.name" class="btn btn-outline-light">
                {{ item.name }}
            </label>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/js/helpers/eventbus';

export default {
    props: {
        filter: {
            type: Object,
            default() {
                return {};
            }
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        multiSelect: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isActive: false,
            selectedFilters: []
        };
    },

    watch: {
        selectedFilters(val) {
            this.$emit('input', val);
        }
    },

    methods: {
        changeHandler(item) {
            if (!this.multiSelect) {
                const array = [];
                array.push(item);
                this.selectedFilters = array;
            }
        },

        removeFilter(filter) {
            this.selectedFilters = this.selectedFilters.filter(
                item => item.filter !== filter.filter
            );
        },

        emitToggleEvent() {
            EventBus.$emit('toggle-sub-item', this.filter.id);
        },

        toggleFilter(id) {
            if (this.filter.id === id) {
                this.isActive = !this.isActive;
            } else {
                this.isActive = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.education-filter {
    margin-bottom: 0.5rem;
}
.education-filter__name {
    font-size: 1.25rem;
    text-transform: uppercase;

    i {
        margin-top: 4px;
    }

    &:hover {
        cursor: pointer;
    }
}

.education-filter__options {
    margin: 0;
    padding-left: 0;
    list-style: none;
    font-weight: $font-weight-light;
    font-size: 1.125rem;
    letter-spacing: 0.33px;
}

.education-filter__input {
    display: none;
}

.education-filter__input + .education-filter__label {
    position: relative;
    margin: 0;
    padding-left: 28px;
    user-select: none;
    &:hover {
        cursor: pointer;
    }
}

.education-filter__input:hover + .education-filter__label:before,
.education-filter__input:checked + .education-filter__label:before {
    opacity: 1;
}
</style>
